import { isBefore, isAfter } from 'date-fns';

export type DateConstraints = {
  min?: Date;
  max?: Date;
};

export default function applyDateConstraints(
  source: Date,
  boundaries: DateConstraints = {},
): Date {
  const { min, max } = boundaries;
  if (min && isBefore(source, min)) {
    return min;
  }
  if (max && isAfter(source, max)) {
    return max;
  }
  return source;
}
